import { render, staticRenderFns } from "./CCoachmark.vue?vue&type=template&id=87b5bde0&scoped=true"
import script from "./CCoachmark.vue?vue&type=script&lang=ts"
export * from "./CCoachmark.vue?vue&type=script&lang=ts"
import style0 from "./CCoachmark.vue?vue&type=style&index=0&id=87b5bde0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b5bde0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default,COverlay: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/COverlay/COverlay.vue').default})
